import { createStoreChunk } from '@core/store'

export type THeaderVariant = 'default' | 'transparent'

type THeaderState = {
    /** Shared open-state for the mobile navigation drawer (<1280px): the header toggles, the drawer reads. */
    isMobileMenuOpen: boolean
    mobileMenuSection: 'user' | null
}

export const headerStore = createStoreChunk<THeaderState>('header')({
    initialState: { isMobileMenuOpen: false, mobileMenuSection: null },
    actions: {
        toggleMobileMenu: (_: undefined, state: THeaderState) => ({
            isMobileMenuOpen: !state.isMobileMenuOpen,
            mobileMenuSection: null,
        }),
        openMobileUserMenu: () => ({ isMobileMenuOpen: true, mobileMenuSection: 'user' as const }),
        closeMobileMenu: () => ({ isMobileMenuOpen: false, mobileMenuSection: null }),
    },
})
